<template>
    <div class="header">
        <div class="headerContent flex_layout flex_y_center">
            <div class="navCon flex_layout flex_y_center flex_x_spacebetween">
                <a class="logo" href="https://www.kuaikanmanhua.com/">
                    <img src="https://static3w.kuaikanmanhua.com/_nuxt/static-kkfront-pc/image/logo.f38006f.png" alt="logo"/>
                </a>
                <div class="input-box">
                    <div @click="search" class="search-icon"><img src="../img/search_icon.png" /></div>
                    <input @input="changeInput" @keyup.enter="search" placeholder="搜索作品名称" class="ip-input" v-model="ipName" />
                    <div class="drop-down" v-show="mindList.length">
                        <div class="search-query">
                            搜索<span class="key-word">{{ ipName }}</span>相关
                        </div>
                        <div
                            class="mind-item"
                            v-for="item in mindList"
                            :key="item"
                            @click="selectMind(item)">{{ item }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bus from '../modules/bus';
import { debounce } from '@kk/utils';
import xss from '@kk/xss';

export default {
    name: 'header',
    data () {
        return {
            ipName: '',
            mindList: []
        };
    },
    mounted () {
        this.addEvent(document.body, 'click', () => {
            this.mindList=[];
        });
        Bus.$on('clearIpName', () => {
            this.ipName = '';
        });
    },
    beforeDestroy () {
        Bus.$off('clearIpName');
    },
    methods: {
        changeInput: debounce(async function () {
            if (!this.ipName) {
                this.mindList = [];
                return;
            }
            const params = {
                url: '/v3/ad/activity/ip_pic/list',
                data: {
                    query: this.ipName
                }
            };
            const {data, code} = await request(params);
            if (code === 200) {
                const list = [];
                (data || []).forEach(item => {
                    !list.includes(item.ip_name) && list.push(item.ip_name);
                });
                this.mindList = list;
            }
        }, 300),

        selectMind (mindIpName) {
            this.ipName = mindIpName;
            this.search();
        },
        search () {
            this.mindList = [];
            Bus.$emit('searchByIpName', xss(this.ipName));
        },
        addEvent (ele, ev, fn) { //ele为要绑定事件的元素，ev为要绑定的事件名称，fn为绑定事件的函数
            if (ele.attachEvent) {
                ele.attachEvent('on' + ev, fn);
            } else {
                ele.addEventListener(ev, fn, false);
            }
        },
    },
};
</script>

<style lang='scss' scoped>
@import "@/css/common.scss";
.header{
    position: relative;
    width: 100%;
    background: #282828;
    .headerContent{
        box-sizing: border-box;
        height: 80px;
        width: 100%;
        background: rgba(0,0,0,0.20);
        .navCon{
            margin: 0 auto;
            width: vws(1184px);
            max-width: 1184px;
            .logo{
                font-size:0;
                display:inline-block;
                width: vws(91px);
            }
            .input-box{
                padding-left: vws(19px);
                position: relative;
                width: vws(260px);
                height: vws(46px);
                max-width: 260px;
                max-height: 46px;
                min-width: 180px;
                min-height: 32px;
                border-radius: vws(23px);
                background: #FFFFFF;
                display: flex;
                align-items: center;
                .search-icon{
                    cursor: pointer;
                    width: vws(31px);
                    height: vws(25px);
                    max-width: 31px;
                    max-height: 25px;
                    min-width: 22px;
                    min-height: 17px;
                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
                .ip-input{
                    width: vws(210px);
                    max-width: 210px;
                    min-width: 138px;
                    display: block;
                    height: 100%;
                    padding-left: vws(14px);
                    padding-right: vws(19px);
                    background: #FFFFFF;
                    border-radius: vws(23px);
                    font-size: vws(20px);
                    color: #A9A9A9;
                }
                .drop-down{
                    position: absolute;
                    border-radius: 6px;
                    top: vws(52px);
                    width: vws(260px);
                    height: 300px;
                    max-width: 260px;
                    min-width: 180px;
                    background: #FFFFFF;
                    z-index: 999;
                    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.16);
                    overflow: auto;
                    left: 0;
                    .search-query{
                        padding: 10px 12px;
                        line-height: 20px;
                        color: #999999;
                        font-size: 14px;
                        .key-word{
                            color: #F5A623;
                        }
                    }
                    .mind-item{
                        padding: 0 12px;
                        height: 32px;
                        line-height: 32px;
                        font-size: 14px;
                        color: #202020;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;

                        &:hover{
                            background: #EEEEEE;
                        }
                    }
                }
            }
        }
    }
}
@media (max-width:1184px) {
    .header{
        .headerContent{
            height: vws(80px);
            padding: 0 vws(50px);

        }
    }
}
@media (max-width:520px) {
    .header{
        .headerContent{
            .navCon{
                .input-box{
                    border-radius: 16px;
                    padding-left: 12px;
                    .ip-input{
                        padding-left: 8px;
                        border-radius: 16px;
                        padding-right: 12px;
                    }
                    .drop-down{
                        top: 34px;
                    }
                }
            }
        }
    }
}
</style>


